export default __webpack_public_path__ + "static/media/Helm of the Firebrand.a307895c.jpg";